export const RouletteTipsTranslation = {
    rewardNames: {
            en: `
Cards will be generated in the roulette from the reward names, with each reward name used as the card text. Enter the names separated by commas.
A reward name can be any task for the streamer, a prize for the viewer, or any other text.
            `,
            uk: `
Із назв нагород у рулетці будуть створені картки з відповідним текстом. Вводьте назви через кому.
Назва нагороди може бути будь-яким завданням для стримера, призом для глядача або будь-яким іншим текстом.
            `
    },
    rarity: {
            en: `
Rarity determines the drop chance of a category in the roulette. Common is the lowest rarity, and Relic is the highest.
If a category contains several rewards, the drop chance of each reward in that category is the category's drop chance divided by the number of rewards in the category.
            `,
            uk: `
Рідкість визначає шанс випадіння категорії в рулетці. Common — найнижча рідкість, а Relic — найвища.
Якщо в категорії кілька нагород, шанс випадіння кожної з них дорівнює шансу випадіння категорії, поділеному на кількість нагород у ній.
            `
    }
}
